<template>
	<div
		class="container xl:container w-full"
		:id="id"
	>
		<slot />
	</div>
</template>

<script lang="ts" setup>
const props = defineProps<{
	id?: string;
}>();
</script>

<style lang="scss">
@use "~/assets/utils.scss" as *;
</style>
